module.exports = {
  devices_import_title: "Import Devices",
  devices_import_cancel: "Cancel",
  devices_import_save: "Import",

  devices_import_inventory_location: "Inventory Location",
  devices_import_location: "Location",
  devices_import_manufacturer: "Manufacturer",
  devices_import_account: "Account",
  devices_import_puls_account: "Puls Account",
  devices_import_shipper_id: "Shipper ID",
  devices_import_get_devices: "Get Devices",

  devices_import_po: "PO",
  devices_import_imei: "IMEI",
  devices_import_serial: "Serial",
  devices_import_iccid: "ICCID",
  devices_import_msisdn: "MSISDN",
  devices_import_serial_imei: "Serial/IMEI",
  devices_import_serial_drid: "Serial/DRID",
  devices_import_valid_serial_8_minlength: "Serial should be at least 8 characters",
  devices_import_valid_serial_minlength: "Serial should be at least 3 characters",
  devices_import_valid_serial_imei_minlength: "Serial/IMEI should be at least 15 characters",
  devices_import_valid_serial_imei_minlength_geo: "Serial/IMEI should be at least 12 characters",
  devices_import_valid_serial_imei_minlength_queclink: "Serial/IMEI should be at least 15 characters",
  devices_import_valid_serial_drid_minlength: "Serial/DRID should be at least 12 characters",
  devices_import_valid_imei_minlength: "IMEI should be 15-16 characters",
  devices_import_valid_imei_maxlength: "IMEI should be 15-16 characters",
  devices_import_valid_iccid_minlength: "ICCID should be 19-20 characters",
  devices_import_valid_iccid_maxlength: "ICCID should be 19-20 characters",
  devices_import_valid_msisdn_minlength: "Phone # contains less than 10 numbers",
  devices_import_valid_msisdn_maxlength: "Phone # contains over 15 numbers",
  devices_import_valid_duplicated_imei: "The IMEI was previously added",
  devices_import_valid_duplicated_esn: "The Serial was previously added",
  devices_import_valid_duplicated_iccid: "The SIM # was previously added",
  devices_import_valid_duplicated_msisdn: "The Phone # was previously added",

  devices_import_csv_file_instructions_serial: "You must upload a CSV file with the field Serial",
  devices_import_order_number: "Order Number",
  devices_import_csv_file: "CSV File",
  devices_import_csv_file_instructions: "You must load a CSV File with this fields in the following order: Serial",
  devices_import_import_modal_title: "Import Devices",
  devices_import_import_modal_content: "Are you sure to import devices?",
  devices_import_import_confirmation_warning: "Warning, If a device is imported the previous data on the grid will be lost",

  devices_import_device_type: "Device Model",
  devices_import_carrier: "Carrier",
  devices_import_purchase_order: "Purchase Order",
  devices_import_sim: "SIM #",
  devices_import_phone: "SIM Phone #",

  devices_import_add_new: "Add New",
  devices_import_add_savechanges: "Save Changes",
  devices_import_add_cancelchanges: "Cancel Changes",

  devices_import_summary_title: "Devices To Import",
  devices_import_title: "Add Devices",
  devices_import_result_title: "Result",
  devices_import_add_succesfuly: "devices process successfully",
  devices_import_of: "of",
  devices_import_status: "Import Status ",
  devices_import_message: "Message",
  devices_import_import_others: "Import",
  devices_import_export_others: "Export",

  devices_import_csv_file_download_sample: "Download Sample",
  devices_import_error_unselected_devices: "You must selected a least one device of the list",
  devices_import_csv_file_sample_csv: "Samples CSV Files",

  devices_import_calamp_csv_file_instructions: "You must load a CSV File",
  devices_import_device_message: "Message",

  devices_import_invalid_esn: "Invalid ESN",
  devices_import_invalid_imei: "Invalid IMEI",
  devices_import_invalid_device_model: "Part number is not registered in PM",
  devices_import_device_invalid_purchase_order: "Invalid Purchase Order",
  devices_import_invalid_serial_drid: "Invalid Serial/DRID",

  devices_import_csv_import: "Import using Manufacturer CSV File",
  devices_import_manual_import: "Import Manually (No CSV)",

  devices_import_imei_repeated_in_list: "Device is already in this form",
  devices_import_device_search_criteria: "Serial",
  devices_import_device_add: "Add",
  devices_import_error_add_devices: "You must add a least one device to the list",

  devices_import_valid_iccid_min: "ICCID should be positive",
  devices_import_valid_msisdn_min: "MSISDN should be positive",

  devices_import_device_not_found: "Device not found",
  devices_import_device_unable_to_process: "Unable to process request at this time. Please make sure you are entering a right ESN/IMEI for a Calamp device",
  devices_import_device_not_found_calamp: "The device ESN/IMEI has not been found in PULS file",

  devices_import_calamp_errors: "The following errors were found",

  devices_import_get_phone_numbers: "Get Phone Numbers",

  devices_import_retreving_sim_info: "Retrieving SIM Info",
  devices_import_retreving_sim_info_error: "SIM info not found",
  devices_import_load_phone_number_success: "Load Success",
  devices_import_fetching_phone_numbers: "Fetching phone numbers, this may take a moment...",

  devices_import_part_number: "Part Number",

  devices_import_service: "Service",
  devices_import_ref_number: "Reference #",

  devices_import_label: "Label",
  devices_import_subscription_number: "Subscription #",

  devices_import_error_msisdn_missing: "phone number is length less than 10 numbers",

  devices_import_save_error: "Devices could not be imported",
  devices_import_message_result: "Message",
  devices_import_message_result_success: "Successfully imported and assigned",
  devices_import_device_not_found: "Device not found",
  devices_import_password: "Password",
  devices_import_hardware_version: "Hardware Version",
  devices_import_firmware: "Firmware",
  devices_import_sim_state: "SIM State",
  devices_import_error_200: "Camera password error",
  devices_import_error_201: "camera operation failed",
  devices_import_error_202: "Camera does not exist",
  devices_import_error_204: "Sync camera error",
  devices_import_error_24: "Not authorized",
  devices_import_error_23: "Authentication failed",
  devices_import_device_model: "Device Model",
  devices_import_activate_sim_title: "VidFleet SIM Activation",
  devices_import_activate_sim_error_message: "VidFleet SIM's could not be activates",
  devices_import_activate_sims: "Activate SIM Cards",
  devices_import_missing_imei_or_serial: "Missing IMEI or Serial",
  devices_import_file_not_supported: "File not supported",
  devices_import_unknow_vidfleet_model: "Unknown VidFleet device model",
  devices_import_transaction_request_message:"The import devices request has been received. Click here to see the import status.",
  devices_import_click_progress_transaction: "To see import progress click here",
  devices_import_csv_file_instructions_queclink: "You must load a CSV File with this fields in the following order: IMEI, SIM#, Phone#",
  devices_import_csv_file_instructions_pui: "You must load a CSV File with this fields in the following order: IMEI, SIM#, Phone#",
  devices_import_error_limit_devices: "Only 300 device can be imported at once",
  devices_import_devices_deactiavted_sim: "There are devices with SIM deactivated",
  devices_import_sim_provider_account: "SIM Provider Account",
  devices_import_reference: "Reference",

  devices_import_features: "Features",
  devices_import_status: "Status",

  devices_import_of: "of",
  devices_import_devices_enabled: "devices enabled",

  devices_import_enable: "Enable",
  devices_import_disable: "Disable",

  devices_import_promiles: "Promiles",
  devices_import_driver_behavior: "Driver Behavior",
  devices_import_ota: "OTA",
  devices_import_sms: "SMS",
  devices_import_starter: "Starter",
  devices_import_motion: "Motion",
  devices_import_obdii_alerts: "OBDII Alerts",
  devices_import_com_data: "ComData",
  devices_import_pressure_pro: "PressurePro",
  devices_import_tow: "Tow",
  devices_import_ttu: "TTU",

  devices_import_analytics: "Analytics",
  devices_import_jbus: "JBus",
  devices_import_vbus: "VBus",
  devices_import_battery: "Battery",
  devices_import_hours_enable: "Hours Enable",
  devices_import_odometer_enable: "Odometer Enable",
  devices_import_device_category_asset: "Asset",
  devices_import_device_category_fleet: "Fleet",
  devices_import_apu: "Apu",
  devices_import_hybrid: "Hybrid",
  devices_import_promiles_odometer_calculated: "Promiles Odometer Calculated",
  devices_import_use_ecu_odometer: "Use Ecu Odometer",
  devices_import_use_ecu_engine_hours: "Use Ecu Engine Hours",
  devices_import_use_ecu_speed: "Use Ecu Speed",
  devices_import_use_ecu_vin: "Use Ecu VIN",
  devices_import_show: "Show In Web",

  devices_import_valid_iccid_minlength_general: "There are devices ICCID less than 19-20 characters",
  devices_import_error_msisdn_missing_general: "There are devices without phone numbers or with length less than 10 numbers",
  devices_import_device_not_found_calamp: "Show In Web",
  devices_import_device_repeated_in_list: "Some repeated esns were no added to the list",
  devices_import_error_devices_selected: "There are selected devices with errors",
  devices_import_error_devices: "There are devices with errors",
  devices_import_error_no_devices: "You must have a least one device on the list",
  devices_import_linked_mode: "Paired Mode",
  devices_import_invalid_puls_customer: "Invalid Calamp Account",
  devices_import_camera_mode: "Camera Mode",
  devices_import_camera_gps: "Camera as GPS",
  devices_import_camera_paired_mode: "Paired Mode",

  devices_import_valid_iccid_only_numbers: "ICCID should be only numbers",
  devices_import_valid_iccid_only_numbers_general: "There are devices that contain letters in the phone number",
  devices_import_valid_msisdn_only_numbers: "MSISDN should be only numbers",
  devices_import_valid_msisdn_only_numbers_general: "There are devices that contain letters in the phone number",
  devices_import_cariq: "Car IQ",
  devices_import_not_cerebrum: "CerebrumX integration need to be enabled and 'ACTIVE' to import devices",
  devices_import_csv_file_instructions_cerebrumx: "You must load a CSV File with this fields in the following order: VIN, PACKAGENAME",
  devices_import_invalid_vin:"Invalid VIN",
  devices_import_invalid_package_name:"Invalid Package Name",
  devices_import_vin:"VIN",
  devices_import_package_name: "Package Name",
  devices_import_valid_vin_minlength: "VIN should be 17 characters",
  devices_import_valid_duplicated_vin: "The VIN was previously added",
  devices_import_csv_file_instructions_telitek: "You must load a CSV File with this fields in the following order: SERIAL, IMEI, SIM#, Phone#",
  devices_import_csv_file_instructions_pacific_track: "You must load a CSV File with this fields in the following order: IMEI, SIM#, Phone#",
  devices_import_csv_file_instructions_zonar: "You must load a CSV File with this fields in the following order: SERIAL",
  devices_import_csv_file_instructions_genx: "You must load a CSV File with this fields in the following order: SERIAL, IMEI, SIM#, Phone#",
  devices_import_csv_file_instructions_digital_matter: "You must load a CSV File with this fields in the following order: IMEI",
  devices_import_not_zonar: "The Zonar integration must be added to the account in order to import devices",
  devices_import_zonar_account_id: "Zonar Account ID",
  devices_import_carb: "Carb",
  devices_import_csv_file_instructions_m2md: "You must load a CSV File with this fields in the following order: IMEI, ICCID",
  devices_import_csv_file_instructions_smartwitness: "You must load a CSV File with this fields in the following order: SERIAL/DRID, ICCID",
}
